import { useEffect } from 'react';
import { useToasts } from 'react-toast-notifications'
import { useLocation, useHistory } from 'react-router-dom';
import { getUserInfo, setUserTokenToPay, setUserTemporary, setPayOnLinkShareMode, removePayOnLinkShareMode, getTokenTemporary } from '_utils/localData';
import { parseJwt } from '_utils/function';
import authApi from '../../api/auth';

const ProtectedRoutePayment = () => {
  const { search } = useLocation();
  const { addToast } = useToasts()
  const history = useHistory();
  const tokenToPayTemporary = getTokenTemporary()
  const params = new URLSearchParams(search);
  const ref = params.get('ref');
  const uid = params.get('uid');

  useEffect(() => {
    const user = getUserInfo();

    const setTokenToPay = async () => {
      try {
        const isExpired = () => {
          if (!tokenToPayTemporary) return true;
          try {
            const decoded = parseJwt(tokenToPayTemporary);
            return decoded.exp * 1000 < Date.now();
          } catch (e) { return true; }
        };

        if (isExpired()) {
          const { msgResp } = await authApi.getTokenToPay(uid, ref);
          setUserTokenToPay(msgResp);
          setUserTemporary(parseJwt(msgResp));
        }
        setPayOnLinkShareMode(true);
        // Ensure preserve hitpay params (status=completed,reference)
        history.push(`/event/purchase-detail-share${search}`)
      } catch (e) {
        addToast(e.msgResp, { appearance: 'error', autoDismiss: true })
      }
    };

    if (!user) {
      if (uid) {
        setTokenToPay();
        return;
      }
      if (tokenToPayTemporary) {
        history.push(`/event/purchase-detail-share${search}`);
        return;
      }
    }

    removePayOnLinkShareMode()
    history.push(`/event/purchase-detail${search}`);
  }, [uid, ref, history, search, tokenToPayTemporary]);

  return null;
};

export default ProtectedRoutePayment;
